import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { ApiService } from 'app/api-services/api.service';
import { ExcelDownloadService } from 'app/excel-download.service';
import { MetaService } from 'app/meta.service';
import { ToastrService } from 'ngx-toastr';


export const MY_FORMATS = {
  parse: {
    dateInput: 'MM-YYYY',
  },
  display: {
    dateInput: 'MM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-synergy-report',
  templateUrl: './synergy-report.component.html',
  styleUrls: ['./synergy-report.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class SynergyReportComponent {

  payrollDate = null;

  constructor(public apiService: ApiService, private toastr: ToastrService, private excelDownloadService: ExcelDownloadService, public _formBuilder: FormBuilder, public meta: MetaService, private datePipe: DatePipe) {

  }

  getSynergyReport() {
    let payrollDate = new Date(this.payrollDate)
    let payrollMonth = payrollDate.getMonth() + 1
    let payrollYear = payrollDate.getFullYear()
    let requestBody = {
      payroll_month: payrollMonth,
      payroll_year: payrollYear
    }

    this.apiService.getSynergyReport(requestBody,{}).subscribe((response) => {
      if (response.status == "success") {
        let payrollData = response.data.sessions
        let fileName = "SynergyReport_" + payrollMonth + "/" + payrollYear + '.' + 'xlsx'
        let headerNames = ["User Name", 'Trainer Name', 'Session Count']
        this.excelDownloadService.downloadExcelFile(payrollData, headerNames, fileName);
        this.meta.dialogClosed = false;
        this.resetAll()
      }
    },
    (err) => {
      this.toastr.error(err.error.message)
    })
  }
  // resetall
  resetAll() {
    this.payrollDate = null;
  }

}
